export const BASE_URL = 'https://q-social-backend.vercel.app/api'
